import { STATUS, STATUS_STYLING } from '@/app/data/status_constants';
import CONTACT_TYPE_TO_ICON from '@/app/data/icon_constants';
import { RECORD_TYPE } from '@/app/data/model_constants';

// Tag pill classes [bg, text] for a styling entry, or the fallback when unmapped.
function styling_classes(styling, fallback) {
  return styling ? [styling.TAG_COLOR, styling.TAG_TEXT_COLOR] : fallback;
}

const DEFAULT_TYPE_CONFIG = Object.freeze({ LABEL: '', ICON: ['far', 'user'] });

export const TODO_V2_ICON = Object.freeze(['far', 'list-check']);

export const TODO_V2_COMPLETED_BG = 'bg-green-50';

// TodoV2 statuses — string-backed Postgres enum on the backend, so the raw
// status value ('draft' | 'pending' | 'completed') is what ransack filters on.
export const TODO_V2_STATUS = Object.freeze({
  DRAFT: 'draft',
  PENDING: 'pending',
  COMPLETED: 'completed',
});

export const TODO_V2_STATUS_STYLING = Object.freeze({
  [TODO_V2_STATUS.DRAFT]: STATUS_STYLING[STATUS.DEFAULT],
  [TODO_V2_STATUS.PENDING]: STATUS_STYLING[STATUS.WARNING],
  [TODO_V2_STATUS.COMPLETED]: STATUS_STYLING[STATUS.SUCCESS],
});

export const TODO_GROUP_CATEGORY = Object.freeze({
  CONFIRMATION: 'confirmation',
  UPLOAD: 'upload',
});

export const TODO_GROUP_CATEGORY_STYLING = Object.freeze({
  [TODO_GROUP_CATEGORY.CONFIRMATION]: STATUS_STYLING[STATUS.INFO],
  [TODO_GROUP_CATEGORY.UPLOAD]: STATUS_STYLING[STATUS.PRIMARY],
});

export const TODO_GROUP_CATEGORY_ICON = Object.freeze({
  [TODO_GROUP_CATEGORY.CONFIRMATION]: ['far', 'square-check'],
  [TODO_GROUP_CATEGORY.UPLOAD]: ['far', 'file-arrow-up'],
});

export function status_styling(status) {
  return styling_classes(TODO_V2_STATUS_STYLING[status], []);
}

export function category_styling(category) {
  return styling_classes(TODO_GROUP_CATEGORY_STYLING[category], null);
}

// Assignee types are profile-type strings (RECORD_TYPE), so the shared
// contact icons apply.
export const TODO_ASSIGNEE_TYPE_CONFIG = Object.freeze({
  [RECORD_TYPE.EMPLOYEE]: Object.freeze({
    LABEL: 'todo_v2.assignee_types.employee',
    ICON: CONTACT_TYPE_TO_ICON[RECORD_TYPE.EMPLOYEE],
  }),
  [RECORD_TYPE.CUSTOMER]: Object.freeze({
    LABEL: 'todo_v2.assignee_types.customer',
    ICON: CONTACT_TYPE_TO_ICON[RECORD_TYPE.CUSTOMER],
  }),
  [RECORD_TYPE.PARTNER]: Object.freeze({
    LABEL: 'todo_v2.assignee_types.partner',
    ICON: CONTACT_TYPE_TO_ICON[RECORD_TYPE.PARTNER],
  }),
});

export function type_config(type) {
  return TODO_ASSIGNEE_TYPE_CONFIG[type] || DEFAULT_TYPE_CONFIG;
}
